import { render, staticRenderFns } from "./userManagement_userRolesSon.vue?vue&type=template&id=3089e0c4&"
import script from "./userManagement_userRolesSon.vue?vue&type=script&lang=js&"
export * from "./userManagement_userRolesSon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports